import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=aa8bcbc4&scoped=true&"
import script from "./Programs.vue?vue&type=script&lang=js&"
export * from "./Programs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8bcbc4",
  null
  
)

export default component.exports